const ChatState = {
  CHAT_NOT_INITIALIZED: 'CHAT_NOT_INITIALIZED',
  CHAT_INITIALIZING: 'CHAT_INITIALIZING',
  CHAT_INITIALIZED: 'CHAT_INITIALIZED',
  CHAT_ERROR: 'CHAT_ERROR',
};

export default ChatState;
